import { FC, useState, useEffect, useRef } from 'react';
import { ProImage } from '../antd';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import Helper from '../Helper';
import './style.less';

export interface ImagesProps {
  /** 图片路径组 */
  images: string[];
}
/** 多图查看器 */
const Images: FC<ImagesProps> = props => {
  const { images = [] } = props;
  const wrapper = useRef<HTMLDivElement>(null);
  const [current, setCurrent] = useState<number>(0);
  useEffect(() => {
    if (wrapper.current) {
      wrapper.current.scrollLeft = 100 * current;
    }
  }, [current]);
  const handleClick = (num: number) => {
    if (num < 0) num = 0;
    if (num > images.length - 3) num = images.length - 3;
    setCurrent(num);
  };
  const handleViewImages = (image: string) => {
    Helper.previewImage({
      current: image,
      images: images,
    });
  };
  return (
    <div className="yb-images-wrapper">
      {images.length > 3 && (
        <>
          <div
            className="yb-images-flag yb-images-left"
            onClick={() => handleClick(current - 1)}
          >
            <LeftOutlined />
          </div>
          <div
            className="yb-images-flag yb-images-right"
            onClick={() => handleClick(current + 1)}
          >
            <RightOutlined />
          </div>
        </>
      )}
      <div className="yb-images" ref={wrapper}>
        <div className="yb-images-content">
          {images.map(image => (
            <div
              key={image}
              className="yb-images-content-item"
              onClick={() => handleViewImages(image)}
            >
              <ProImage src={image} preview={false} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Images;
